import { render } from "./dialog-advance-company.vue?vue&type=template&id=ce886496&scoped=true&ts=true"
import script from "./dialog-advance-company.vue?vue&type=script&lang=ts"
export * from "./dialog-advance-company.vue?vue&type=script&lang=ts"

import "./dialog-advance-company.vue?vue&type=style&index=0&id=ce886496&lang=stylus&scoped=true"
import "./dialog-advance-company.vue?vue&type=style&index=1&id=ce886496&lang=css"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce886496"]])

export default __exports__